// extracted by mini-css-extract-plugin
export default {"contentContainer":"SendReceiptContent_contentContainer__YpTIr"};